import { values } from "lodash";
import React from "react";
import { FormattedMessage } from "react-intl";

export const INTRODUCTION_DISCLAIMER_CONTENT = [
  {
    id: 1,
    title: (
      <FormattedMessage
        id="ProjectStepFormDisclaimer.projectName"
        defaultMessage="Nombre del proyecto"
      />
    )
  },
  {
    id: 2,
    title: (
      <FormattedMessage
        id="ProjectStepFormDisclaimer.productUsed"
        defaultMessage="Productos usados"
      />
    )
  },
  {
    id: 3,
    title: (
      <FormattedMessage
        id="ProjectStepFormDisclaimer.marketSegment"
        defaultMessage="Mercado y segmento"
      />
    )
  },
  {
    id: 4,
    title: (
      <FormattedMessage
        id="ProjectStepFormDisclaimer.countryCity"
        defaultMessage="País y ciudad del proyecto"
      />
    )
  },
  {
    id: 5,
    title: (
      <FormattedMessage
        id="ProjectStepFormDisclaimer.projectPhotos"
        defaultMessage="Fotos del proyecto"
      />
    )
  }
]